import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import {
  BenefitItem,
  BenefitItemContainer,
  BenefitItemText,
} from 'components/domain/fdr-benefits-section/fdr-benefit-items.styles';
import {
  BenefitButtonContainer,
  BenefitContainer,
  BenefitSectionContent,
  BenefitText,
} from 'components/domain/fdr-benefits-section/fdr-benefits-section';
import { Link } from '@hotelplan/components.common.link';

export const CustomBenefitSectionContent = styled(BenefitSectionContent)(
  sx2CssThemeFn({
    backgroundColor: 'blueOcean',
  })
);

export const CustomBenefitContainer = styled(BenefitContainer)(
  ({ theme: { space } }) =>
    sx2CssThemeFn({
      padding: [`40px ${space[3]}`, '80px 20px'],
    })
);

export const CustomBenefitTextWrapper = styled.div(
  sx2CssThemeFn({
    marginBottom: ['40px', '24px'],
    h2: {
      color: 'white',
    },
  })
);

export const CustomBenefitText = styled(BenefitText)(
  sx2CssThemeFn({
    marginLeft: ['initial', 'auto'],
    marginRight: ['initial', 'auto'],
    textAlign: ['initial', 'center'],
  })
);

export const CustomBenefitItemContainer = styled(BenefitItemContainer)(
  sx2CssThemeFn({
    maxWidth: ['initial', '1278px'],
    margin: ['initial', 'auto'],
    gap: ['28px', '20px'],
  })
);

export const CustomBenefitItem = styled(BenefitItem)(
  sx2CssThemeFn({
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',

    '&:not(:last-child)::after': {
      backgroundImage: 'none',
      width: 'initial',
      height: 'initial',
      top: ['calc(100% - 12px)', '50%'],
      left: ['calc(50% - 10px)', '100%'],
      transform: [`rotate(90deg)`, `translateY(-50%)`],
      borderTop: '22px solid transparent',
      borderBottom: '22px solid transparent',
      borderLeft: '20px solid white',
    },
  })
);

export const CustomBenefitItemIcon = styled.div(
  sx2CssThemeFn({
    color: 'white',
  })
);

export const CustomBenefitItemHeader = styled.div(({ theme }) => ({
  fontSize: theme.fontSizes[4],
  fontWeight: 800,
}));

export const CustomBenefitItemText = styled(BenefitItemText)(({ theme }) => ({
  fontSize: theme.fontSizes[1],
  marginLeft: 0,
}));

export const CustomBenefitButtonContainer = styled(BenefitButtonContainer)(
  sx2CssThemeFn({
    marginTop: ['40px', '64px'],
  })
);

export const CustomBenefitButtonLink = styled(Link)(({ theme }) =>
  sx2CssThemeFn({
    ...theme.buttons.primary,
    width: ['initial !important', '100%'],
  })
);
